export const CONTACT_UNSPECIFIED_ACTIVITY = 'Contact unspecified';
export const PROJECT_UNITS_ACTIVITY = 'Project units';
export const TEACHING_DELIVERY_ROW_HEADERS = ['Taught weeks', 'Classes', 'Duration'];
export const TRD_CAN_ASSIGN_HOURS_FIELDS = [
  'trdUnitCoordinationCanAssignHours',
  'trdMarkingCanAssignHours',
  'trdPreparationCanAssignHours',
  'trdCoAssessorDutiesCanAssignHours',
  'trdConsultationCanAssignHours',
  'trdModerationCanAssignHours',
  'trdOtherCanAssignHours',
  'trdUnitDevelopmentCanAssignHours',
];
export const TRD_ASSIGNED_HOURS_FIELDS = [
  'trdUnitCoordinationHours',
  'trdMarkingHours',
  'trdPreparationHours',
  'trdCoAssessorDutiesHours',
  'trdConsultationHours',
  'trdModerationHours',
  'trdOtherHours',
  'trdUnitDevelopmentHours',
];

export const UC_ALLOCATION_METHOD = {
  PLANNED_ENROLMENT_CALCULATION: 'PLANNED_ENROLMENT_CALCULATION' as const,
  RANGE_ALLOCATION: 'RANGE_ALLOCATION' as const,
};

export const DEFAULT_LEAVE_HOURS = 150;
export const MAX_ALLOCATABLE_HOURS = 1875;

export enum PERMISSIONS {
  READ = 'READ',
  READ_WRITE = 'READ-WRITE',
  REPORT = 'REPORT',
}
